// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideWaypoints as RawLucideWaypoints } from "lucide-react";
export const LucideWaypoints = /* @__PURE__ */ createIcon(RawLucideWaypoints, "LucideWaypoints", 2);
